export enum KpiStatusEnum {
    ok = 1,
    alert = 2,
    beyondGoal = 3,
}